import { Tooltip } from 'antd';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye, faFileArrowDown, faPlus } from '@fortawesome/free-solid-svg-icons';


//STYLE
import { ContainerHeader } from './styled';

//APP
import { useFormOsContext } from '../../../../context/FormOsContext';

//COMPONENT
import ButtonCustom from '../../../../../../../../../../../../Components/ButtonCustom';
import ModalCriarMalha from './components/criarMalha';
import { Box } from '../../../../../../../../../../../../Components/CustomUi/box';
import { Inline } from '../../../../../../../../../../../../Components/CustomUi/inline';
import { ModalVerMalha } from '../verMalha';
import { SelecionarTalhaoMalha } from '../selecionarTalhaoMalha';
import { ConfirmarPontosRestantes, EscolherAutoAnalise } from '../autoAnalise';
import { EditarContorno } from './components/editarContorno';
import { ModalNovaAnalise } from './components/novaAnalise';
import { UploadFileCustom } from '../../../../../../../../../../../../Components/CustomUi/uploadFileCustom';

/** Cabeçalho da metade "Análises": ações (criar/importar/nova análise, editar contorno, ver malha) + infos. */
export function HeaderAnalises() {
    const {
        campos,
        analises: {
            malha,
            talhaoArea,
            pontosTotalMalha,
            importarMalha,
            talhaoKml,
            setTalhaoKml,
            salvarContornoEditado,
            setTalhaoArea,
            // Fluxo de micronutrientes (auto-análise)
            emCicloMicro,
            abrirEscolhaAutoAnalise,
            abrirConfirmarRestante,
            opcoesAutoAnalise,
            setOpcoesAutoAnalise,
            iniciarCicloMicro,
            concluirSelecaoMicro,
            confirmarEscolhaAutoAnalise,
            gerarAnalisesAutomaticas,
            encerrarCicloMicro,
            // Seleção de talhão (zip multi-talhão)
            abrirSelecaoTalhaoMalha,
            colecoesMalha,
            colecaoSelecionada,
            setColecaoSelecionada,
            confirmarTalhaoDaMalha,
            cancelarTalhaoDaMalha,
            setMalha,
            malhaShp,
            setMalhaShp,
            setPontosTotalMalha,
            // Nova análise
            grupoAnalises,
            grupoAnalisesTratado,
            abrirModalNova,
            setAbrirModalNova,
            id_em_edicao,
            cor,
            setCor,
            tipo_analise_selecionada,
            setTipo_analise_selecionada,
            tipo_analise_selecionada_id,
            setTipo_analise_selecionada_id,
            pontos_selecionados,
            setPontos_selecionados,
            pontos_selecionados_adicionados,
            setPontos_selecionados_adicionados,
            salvarPontosSelecionados,
            fecharModalNova,
            // Ver malha / editar contorno
            analises,
        },
    } = useFormOsContext()

    const [abrirCriarMalha, setAbrirCriarMalha] = useState(false)
    const [selecionarTodos, setSelecionarTodos] = useState(false)

    // Ver malha
    const [abrirVerMalha, setAbrirVerMalha] = useState(false)
    const [analises_ver, setAnalises_ver] = useState<any[]>([])
    const [selecionado, setSelecionado] = useState<number | null>(null)

    // Editar contorno
    const [abrirEditarContorno, setAbrirEditarContorno] = useState(false)

    const desabilitarNovaAnalise =
        (malha?.length ?? 0) === 0 || !talhaoArea || (grupoAnalises?.length ?? 0) === 0

    const desabilitarEditarContorno = !talhaoArea || Number(talhaoArea) === 0
    const desabilitarVerMalha = (analises?.length ?? 0) <= 0

    function verMalhaGeral() {
        setAnalises_ver(analises)
        setAbrirVerMalha(true)
    }

    function fecharVerMalha() {
        setSelecionado(null)
        setAnalises_ver([])
        setAbrirVerMalha(false)
    }

    return (
        <ContainerHeader>
            <Inline alignItems='center'>
                <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <ButtonCustom
                        icon={<FontAwesomeIcon icon={faPlus} />}
                        onClick={() => setAbrirCriarMalha(true)}
                    >
                        Criar malha
                    </ButtonCustom>
                    <UploadFileCustom
                        label='Importar malha geral'
                        accept='.dbf, .shp, .shx, .zip'
                        onFileSelect={importarMalha}
                        style={{ height: 40 }}
                        icon={faFileArrowDown}
                    />
                </Box>
                <Tooltip
                    title={
                        desabilitarNovaAnalise
                            ? 'Importe ou crie uma malha e selecione o laboratório primeiro'
                            : undefined
                    }
                >
                    <span>
                        <ButtonCustom
                            icon={<FontAwesomeIcon icon={faPlus} />}
                            disabled={desabilitarNovaAnalise}
                            onClick={() => setAbrirModalNova(true)}
                        >
                            Nova análise
                        </ButtonCustom>
                    </span>
                </Tooltip>
            </Inline>

            <Inline alignItems='center' justifyContent='space-between'>
                <div className='infos'>
                    <span>Pontos</span>
                    <p>{pontosTotalMalha}</p>
                </div>
                <div className='infos'>
                    <span>Área</span>
                    <p>{talhaoArea ? `${talhaoArea} ha` : '0 ha'}</p>
                </div>
                <ButtonCustom
                    type='tertiary'
                    icon={<FontAwesomeIcon icon={faEdit} />}
                    disabled={desabilitarEditarContorno}
                    onClick={() => setAbrirEditarContorno(true)}
                >
                    Editar contorno
                </ButtonCustom>
                <ButtonCustom
                    type='secondary'
                    icon={<FontAwesomeIcon icon={faEye} />}
                    disabled={desabilitarVerMalha}
                    onClick={verMalhaGeral}
                >
                    Ver malha
                </ButtonCustom>
            </Inline>

            <ModalCriarMalha
                isOpen={abrirCriarMalha}
                onClose={() => setAbrirCriarMalha(false)}
                talhaoKml={talhaoKml}
                setTalhaoKml={setTalhaoKml}
                setTalhaoArea={setTalhaoArea}
                setMalha={setMalha}
                setMalhaShp={setMalhaShp}
                setPontosTotalMalha={setPontosTotalMalha}
            />

            <ModalNovaAnalise
                isOpen={abrirModalNova}
                onClose={fecharModalNova}
                talhaoGeoJson={talhaoKml}
                initialPoints={malha}
                id={id_em_edicao}
                cor={cor}
                setCor={setCor}
                tipo_analise_selecionada={tipo_analise_selecionada}
                setTipo_analise_selecionada={setTipo_analise_selecionada}
                tipo_analise_selecionada_id={tipo_analise_selecionada_id}
                setTipo_analise_selecionada_id={setTipo_analise_selecionada_id}
                pontos_selecionados={pontos_selecionados}
                setPontos_selecionados={setPontos_selecionados}
                pontos_selecionados_adicionados={pontos_selecionados_adicionados}
                setPontos_selecionados_adicionados={setPontos_selecionados_adicionados}
                malhaShp={malhaShp}
                setMalhaShp={setMalhaShp}
                selecionarTodos={selecionarTodos}
                setSelecionarTodos={setSelecionarTodos}
                grupoAnalises={grupoAnalises}
                grupoAnalisesTratado={grupoAnalisesTratado}
                salvarPontosSelecionados={salvarPontosSelecionados}
                analises_salvas={analises}
                em_ciclo_micro={emCicloMicro}
                iniciarCicloMicro={iniciarCicloMicro}
                concluirSelecaoMicro={concluirSelecaoMicro}
            />

            <EscolherAutoAnalise
                abrir={abrirEscolhaAutoAnalise}
                selecionadas={opcoesAutoAnalise}
                aoSelecionar={setOpcoesAutoAnalise}
                aoConfirmar={confirmarEscolhaAutoAnalise}
                aoCancelar={encerrarCicloMicro}
            />

            <ConfirmarPontosRestantes
                abrir={abrirConfirmarRestante}
                aoResponder={gerarAnalisesAutomaticas}
            />

            <ModalVerMalha
                isOpen={abrirVerMalha}
                onClose={fecharVerMalha}
                talhaoGeoJson={talhaoKml}
                initialPoints={malha}
                analises={analises_ver}
                selecionado={selecionado}
                setSelecionado={setSelecionado}
                nomePropriedade={campos.propriedade}
                nomeTalhao={campos.talhao}
            />

            <SelecionarTalhaoMalha
                abrir={abrirSelecaoTalhaoMalha}
                colecoes={colecoesMalha}
                selecionada={colecaoSelecionada}
                aoSelecionar={setColecaoSelecionada}
                aoConfirmar={confirmarTalhaoDaMalha}
                aoCancelar={cancelarTalhaoDaMalha}
            />

            <EditarContorno
                aberto={abrirEditarContorno}
                contornoInicial={talhaoKml}
                pontos={malha}
                aoFechar={() => setAbrirEditarContorno(false)}
                aoSalvar={(coords) => salvarContornoEditado(coords)}
            />
        </ContainerHeader>
    )
}
